import {inject, injectable} from "inversify";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";

@injectable()
export default class FoundationSeatLimitProvider {
  constructor(
    @inject(ConfigRepository) private configRepository: ConfigRepository
  ) {
  }

  public getLimit(foundationLevel: number): number {
    const definition = this.configRepository.get('stadium.foundations')[foundationLevel - 1];

    return (collect(definition).sum((def: { limit?: number }) => def.limit ?? 0) as number);
  }

  public getDiff(diffToLevel: number) {
    if (diffToLevel > this.configRepository.get('stadium.foundation.maxLevel')) {
      throw 'Maximum foundation level exceeded.';
    }

    const limit = this.getLimit(diffToLevel);

    if (diffToLevel <= 1) {
      return limit;
    }

    return limit - this.getLimit(diffToLevel - 1);
  }
}
